import classNames from 'classnames';
import { useContext, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import { PopupActions } from 'reactjs-popup/dist/types';

import { Animation } from '../../Animations';
import { Popup } from '../Popup';

import { PopupMenuContext } from './Context';
import { PopupMenuProps } from './PopupMenu.types';

/**
 * @deprecated use `Menu` instead
 */
export const PopupMenu = forwardRef<PopupActions, PopupMenuProps>(
  ({ children, trigger, selectedIds, animated, openTriggerClassName, ...props }, ref) => {
    const upperContext = useContext(PopupMenuContext);
    const popup = useRef<PopupActions>(null);
    const [opened, setOpened] = useState(false);

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, react-hooks/exhaustive-deps
    useImperativeHandle(ref, () => popup.current!, [popup.current]);

    // Using a custom React Component as trigger seems to break tooltip position calculation
    // We fix it by wrapping the trigger inside a span tag
    const enhancedTrigger = trigger && (
      <span
        data-triggered={opened ? 'triggered' : undefined}
        className={openTriggerClassName && classNames({ [openTriggerClassName]: opened })}
      >
        {trigger}
      </span>
    );
    return (
      <Popup
        contentStyle={{ width: props.width ? `${props.width}px` : undefined }}
        trigger={enhancedTrigger}
        // Clicking outside also closes any parent menu (can be overriden via the onClose prop)
        {...props}
        ref={popup}
        onOpen={() => {
          setOpened(true);
          props.onOpen?.();
        }}
        onClose={() => {
          setOpened(false);
          props.onClose?.();
          upperContext?.()?.actions?.close();
        }}
        arrow={false}
      >
        <Animation.Unroll visible={opened || !animated}>
          <PopupMenuContext.Provider
            value={() => ({ actions: upperContext?.()?.actions ?? popup.current, selectedIds })}
          >
            <div className={props.childrenClassName}>{children}</div>
          </PopupMenuContext.Provider>
        </Animation.Unroll>
      </Popup>
    );
  }
);
